import { render, staticRenderFns } from "./Etherpad.vue?vue&type=template&id=39f68d48&scoped=true&"
import script from "./Etherpad.vue?vue&type=script&lang=js&"
export * from "./Etherpad.vue?vue&type=script&lang=js&"
import style0 from "./Etherpad.vue?vue&type=style&index=0&id=39f68d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f68d48",
  null
  
)

component.options.__file = "Etherpad.vue"
export default component.exports